import { Reducer } from "redux";
import { DeviceState } from "../types";
import { getDevice } from "../routines";
import { TransactionLogActionTypes } from "../actionTypes";

const deviceState: DeviceState = {
    device: null
};

const device: Reducer<DeviceState> = (state: DeviceState = deviceState, action) => {
  switch (action.type) {
    case getDevice.SUCCESS:
        return {
            ...state,
            device: action.payload,
        }

    case TransactionLogActionTypes.RESET_STATE:
        return deviceState;

    default:
        return state;
    }
}

export default device;